import { Box, Tab, Tabs } from '@mui/material';
import TabPanel from './components/TabPanel';

export interface TabView {
  title: string | React.ReactNode;
  content: React.ReactNode;
}

interface Props {
  currentTabIndex: number;
  setTabIndex: (index: number) => void;
  tabs: TabView[];
}

export const TabbedView = ({ currentTabIndex, setTabIndex, tabs }: Props) => {
  const onTabChange = (_: React.SyntheticEvent, newValue: number) =>
    setTabIndex(newValue);
  return (
    <>
      <Box
        sx={{
          borderBottom: 1,
          paddingBottom: 0,
          marginBottom: '12px',
          borderColor: '#2E2E2E',
        }}
      >
        <Tabs
          value={currentTabIndex}
          onChange={onTabChange}
          sx={({ colors }) => ({
            '& .MuiTab-root': {
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: '400',
              color: colors.white,
              opacity: 0.5,
              letterSpacing: '-0.02px',
              minWidth: 'auto',
              paddingLeft: '0px',
              marginRight: '20px',
              paddingBottom: '10px',
              '&.Mui-selected': {
                color: colors.white,
                opacity: 1,
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: colors.violetBlue,
              height: '2px',
              marginTop: 0,
              paddingTop: 0,
            },
          })}
        >
          {tabs.map((tab, index) => (
            <Tab key={`tab-${index}`} label={tab.title} />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <TabPanel
          key={`tab-panel-${index}`}
          value={currentTabIndex}
          index={index}
        >
          {tab.content}
        </TabPanel>
      ))}
    </>
  );
};
